module.exports = __webpack_public_path__ + "fonts/Raleway-SemiBoldItalic.fa332eb7.ttf";